export default "__VITE_ASSET__c2675f9b__"